import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutTopMatchProfileList extends Layout {
    buttonCopyProfile: Button;
    layoutheaderTopMatchProfileList: LayoutHeader;
    sourceTopmatchProfile: DataSource;
    tableTopMatchProfiles: Table;
}
